module.exports = __webpack_public_path__ + "img/couponDoctor_e.02133424.png";